module.exports = __webpack_public_path__ + "img/Interreg.b59bc9d4.png";